/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateUserMetricCommand } from '../model/createUserMetricCommand';
import { CreateUserMetricCommandResult } from '../model/createUserMetricCommandResult';
import { GetUserMetricQueryResult } from '../model/getUserMetricQueryResult';
import { GetUserMetricsQueryResult } from '../model/getUserMetricsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class UserMetricsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [MOBILE] Gets all of the current user&#x27;s metrics
     * Returns every metric the caller owns (attached to goals or not) with its latest value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserMetricsGet(observe?: 'body', reportProgress?: boolean): Observable<GetUserMetricsQueryResult>;
    public meUserMetricsGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserMetricsQueryResult>>;
    public meUserMetricsGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserMetricsQueryResult>>;
    public meUserMetricsGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserMetricsQueryResult>('get',`${this.basePath}/Me/UserMetrics`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Deletes one of the current user&#x27;s own personal metrics
     * Deletes a personal metric the caller created (cascades its goals and measurements). Coach/library metrics are not deletable by the client.
     * @param userMetricUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserMetricsUserMetricUidDelete(userMetricUid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public meUserMetricsUserMetricUidDelete(userMetricUid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public meUserMetricsUserMetricUidDelete(userMetricUid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public meUserMetricsUserMetricUidDelete(userMetricUid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userMetricUid === null || userMetricUid === undefined) {
            throw new Error('Required parameter userMetricUid was null or undefined when calling meUserMetricsUserMetricUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Me/UserMetrics/${encodeURIComponent(String(userMetricUid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [MOBILE] Gets a single one of the current user&#x27;s metrics
     * Returns one metric the caller owns (with its latest value); the Metric is null when it is not the caller&#x27;s own metric
     * @param userMetricUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public meUserMetricsUserMetricUidGet(userMetricUid: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserMetricQueryResult>;
    public meUserMetricsUserMetricUidGet(userMetricUid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserMetricQueryResult>>;
    public meUserMetricsUserMetricUidGet(userMetricUid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserMetricQueryResult>>;
    public meUserMetricsUserMetricUidGet(userMetricUid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userMetricUid === null || userMetricUid === undefined) {
            throw new Error('Required parameter userMetricUid was null or undefined when calling meUserMetricsUserMetricUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserMetricQueryResult>('get',`${this.basePath}/Me/UserMetrics/${encodeURIComponent(String(userMetricUid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a client&#x27;s metrics
     * 
     * @param userUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userMetricsGet(userUid?: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserMetricsQueryResult>;
    public userMetricsGet(userUid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserMetricsQueryResult>>;
    public userMetricsGet(userUid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserMetricsQueryResult>>;
    public userMetricsGet(userUid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (userUid !== undefined && userUid !== null) {
            queryParameters = queryParameters.set('userUid', <any>userUid);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserMetricsQueryResult>('get',`${this.basePath}/UserMetrics`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Attaches a metric to a client
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userMetricsPost(body?: CreateUserMetricCommand, observe?: 'body', reportProgress?: boolean): Observable<CreateUserMetricCommandResult>;
    public userMetricsPost(body?: CreateUserMetricCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateUserMetricCommandResult>>;
    public userMetricsPost(body?: CreateUserMetricCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateUserMetricCommandResult>>;
    public userMetricsPost(body?: CreateUserMetricCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<CreateUserMetricCommandResult>('post',`${this.basePath}/UserMetrics`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Detaches a metric from a client
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userMetricsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public userMetricsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public userMetricsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public userMetricsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userMetricsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/UserMetrics/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets a single client metric with its goals
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userMetricsUidGet(uid: string, observe?: 'body', reportProgress?: boolean): Observable<GetUserMetricQueryResult>;
    public userMetricsUidGet(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetUserMetricQueryResult>>;
    public userMetricsUidGet(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetUserMetricQueryResult>>;
    public userMetricsUidGet(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling userMetricsUidGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetUserMetricQueryResult>('get',`${this.basePath}/UserMetrics/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
